import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './assets-css/global.css'
import * as serviceWorker from './serviceWorker';
import './i18n/index';

const container = document.getElementById('root');

ReactDOM.render(
    <React.StrictMode>
    <App />
  </React.StrictMode>, container);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
